import { Services } from "appworks/services/services";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { PartnerConnectCollectCommand } from "./partner-connect-collect-command";

export function PartnerConnectEndCommand() {
    return new Sequence<void>([
        () => Contract.wrapPromise(PartnerConnectManager.getEmitters()?.spinEnded()),
        () => PartnerConnectCollectCommand(),
        () => Contract.wrapPromise(PartnerConnectManager.getEmitters()?.gameRoundEnded()),
        () => Contract.wrap(() => PartnerConnectManager.prepaidUpdate()),
        () => Services.autoplay.updateWinLoss()
    ]);
}
